import { createSlice } from "@reduxjs/toolkit";

// Define the initial state structure
const initialState = {
    type: "",
    phases: [
        {
            phasenumber: 0,
            phasename: "",
            goals: [],
        },
    ],
    category: "",
    name: "",
    category_numeric: "",
    overwrite: false,
};

const CustomCampaign = createSlice({
    name: "customCampaign",
    initialState,
    reducers: {
        setCustomCampaign: (state, action) => {
            return { ...state, ...action.payload };
        },
        setCustomCampaignName: (state, action) => {
            state.name = action.payload;
        },
        setCustomCampaignCategory: (state, action) => {
            state.category = action.payload.name;
            state.category_numeric = Number(action.payload.value); // Ensure it's numeric
        },

        // CRUD operations for Phases
        addPhase: (state, action) => {
            state.phases.push(action.payload);
        },
        updatePhase: (state, action) => {
            const { index, updatedPhase } = action.payload;
            if (state.phases[index]) {
                Object.assign(state.phases[index], updatedPhase); // ✅ Only updates modified fields
            }
        },
        deletePhase: (state, action) => {
            state.phases.splice(action.payload, 1);
        },


        // CRUD operations for Goals
        addGoal: (state, action) => {
            const { phaseIndex, goal } = action.payload;
            if (state.phases[phaseIndex]) {
                state.phases[phaseIndex].goals.push(goal);
            }
        },
        updateGoal: (state, action) => {
            const { phaseIndex, goalIndex, updatedGoal } = action.payload;
            if (state.phases[phaseIndex]?.goals[goalIndex]) {
                Object.assign(state.phases[phaseIndex].goals[goalIndex], updatedGoal);
            }
        },
        deleteGoal: (state, action) => {
            const { phaseIndex, goalIndex } = action.payload;
            if (state.phases[phaseIndex]) {
                state.phases[phaseIndex].goals.splice(goalIndex, 1);
            }
        },

        // CRUD operations for Steps
        addStep: (state, action) => {
            const { phaseIndex, goalIndex, step } = action.payload;
            if (state.phases[phaseIndex]?.goals[goalIndex]) {
                state.phases[phaseIndex].goals[goalIndex].steps.push(step);
            }
        },
        updateStep: (state, action) => {
            const { phaseIndex, goalIndex, stepIndex, updatedStep } = action.payload;
            if (state.phases?.[phaseIndex]?.goals?.[goalIndex]?.steps?.[stepIndex]) {
                state.phases[phaseIndex].goals[goalIndex].steps = state.phases[phaseIndex].goals[goalIndex].steps.map(
                    (step, idx) => (idx === stepIndex ? { ...step, ...updatedStep } : step)
                );
            }
        }
        ,

        deleteStep: (state, action) => {
            const { phaseIndex, goalIndex, stepIndex } = action.payload;
            if (state.phases[phaseIndex]?.goals[goalIndex]) {
                state.phases[phaseIndex].goals[goalIndex].steps.splice(stepIndex, 1);
            }
        },
    },
});

// Exporting the actions and reducer
export const {
    setCustomCampaign,
    addPhase,
    updatePhase,
    deletePhase,
    addGoal,
    updateGoal,
    deleteGoal,
    addStep,
    updateStep,
    deleteStep,
    setCustomCampaignName,
    setCustomCampaignCategory,
} = CustomCampaign.actions;

export default CustomCampaign.reducer;
